import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from 'src/Types/api'

export const syncGridAndSystemProtectionSettings = async (
  emcStorageId: string | null,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void>> => {
  if (!emcStorageId) throw new Error('EMC storage ID is required to sync grid and system protection settings')
  try {
    const response = await authFetch<void>({
      path: `storages/${emcStorageId}/hardware/protection/sync`,
      method: 'POST',
    })

    if (response.status === StatusCodes.NO_CONTENT || response.status === StatusCodes.CREATED) {
      return new ApiResult<void>()
    }

    return new ApiResult<void>(null, true)
  } catch (error) {
    return handleFetchError<void>(error)
  }
}
